<script>
  let showBrave = false;
  let monthsRangeNum = 1;
  let monthnum = [];
  let minutes = 45;
  let days = 5;
  let km = 7;
  let dayswithbike = days - 1;
  let newbike = true;
  let health = 1;

  let co2benzin = 0.2;
  let co2elektro = 0.136;
  let co2diesel = 0.219;
  let co2hybrid = 0.142;

  let co2ebike = 0.004;
  let co2bus = 0.064;
  let co2train = 0.036;


  let carAntrieb = co2benzin;
  let oev = 79;
  let antriebselected;

  let co2level = co2benzin;

  let selected = {};
  selected.id = 1;
  selected.text = 'Auto';
  let questions = [
    {id: 1, text: `Auto`},
    {id: 2, text: `Bus`},
    {id: 3, text: `Zug`},
  ];
  let antriebe = [
    {id: 1, text: `Benzin`},
    {id: 2, text: `Diesel`},
    {id: 3, text: `Hybrid`},
    {id: 4, text: `Elektro`},
  ];


  function changeAntrieb(elem) {
    if (elem.id === 1) {
      co2level = co2benzin;
    }
    if (elem.id === 2) {
      co2level = co2diesel;
    }
    if (elem.id === 3) {
      co2level = co2hybrid;
    }
    if (elem.id === 4) {
      co2level = co2elektro;
    }
  }

  function changeco2level(elem) {
    if (elem.id === 1) {
      co2level = co2benzin;
    }
    if (elem.id === 2) {
      co2level = co2bus;
    }
    if (elem.id === 3) {
      co2level = co2train;
    }
    if (elem.id === 4) {
      co2level = co2ebike;
    }
    if (elem.id === 5) {
      co2level = 0.0;
    }
  }

  let dnho = 2;

  function checkDays() {
    if (dayswithbike > 7) {
      dayswithbike = 4;
    }
    if (days > 7) {
      days = 5;
    }
    if (dnho < 7) {
      dnho = 3;
    }
  }

  function checkKm() {
    if (km > 400) {
      km = 20;
    }
  }

  function checkoev() {
    if (oev > 340) {
      oev = 340;
    }
  }

  function checkTime() {
    if (minutes > 300) {
      minutes = 60;
    }
  }

  function handle() {
    showBrave = !showBrave;
  }
</script>


<header>
  <img src="./img/t2.svg" alt="Header Bild mit Fahrrad" class="intro-image">
</header>


<div class="container">
  <!-- Intro -->

  <div class="intro">
    <h1>Bike to work für dein Portemonnaie und die Umwelt</h1>
    <p>Wir beantworten dir in diesem Artikel was passiert, wenn du für deinen Arbeitsweg aufs
      E-Bike oder Velo wechselst. Damit wir dich mit richtigen Daten beraten können brauchen wir ein paar
      Informationen von dir. Die Daten werden nicht gespeichert.
    </p>
  </div>
  <!-- Inputs -->

  <div class="inputs" id="input">
    <h3 style="width: 100%; margin: 10px 0">Dein Weg zum Arbeitsplatz</h3>
    <div class="input-block select" style="width: 100%;">
      <label for="select">Dein aktuelles Verkehrsmittel</label>
      <select bind:value="{selected}" on:change="{changeco2level(selected)}">
        {#each questions as question}
          <option value={question}>
            {question.text}
          </option>
        {/each}
      </select>
    </div>
    <div class="input-block">
      <label for="minutes">Minuten zu deinem Arbeitsplatz (ein Weg)</label>
      <input type="number" min="1" max="300" on:input={() => checkTime()} bind:value={minutes} name="minutes">
    </div>
    <div class="input-block">
      <label for="minutes">Tage in der Woche am Arbeitsplatz</label>
      <input type="number" on:input={() => checkDays()} min="1" max="7" name="days" bind:value={days}>
    </div>
    <div class="input-block">
      <label for="minutes">Ungefähre Kilometer bis zum Arbeitsplatz (ein Weg)</label>
      <input type="number" min="1" on:input={() => checkKm()} max="300" name="km" bind:value={km}>
    </div>
    {#if (selected.id === 3 || selected.id === 2)}
      <div class="input-block">
        <label for="oev">Kosten für den ÖV pro Monat</label>
        <input type="number" min="1" on:input={() => checkoev()} max="300" name="oev" bind:value={oev}>
      </div>

      {/if}
  </div>
  <br>


  <h2>Deine Arbeitsweg mit dem {selected.text}</h2>
  <p>
    Wie lange bist unterwegs? Wie hoch ist dein tatsächliches Pensum?
    Zum Start beantworten wir dir diese zwei Fragen. In der Untenstehenden Tabelle siehst
    du die Stunden, die du fürs pendeln brauchst. Die Arbeitstage sind in 8 Stunden gerechnet.
  </p>
  <table>
    <tr>
      <th>Zeitraum</th>
      <th>Zeit</th>
    </tr>
    <tr>
      <td>Eine Woche</td>
      <td>{((minutes * 2) / 60 * days).toFixed(1)} Stunden oder {((minutes * 2) / 60 * days / 8).toFixed(1)}
        Arbeitstage
      </td>
    </tr>
    <tr>
      <td>Ein Monat</td>
      <td>{((minutes * 2) / 60 * days * 4).toFixed(1)} Stunden oder {((minutes * 2) / 60 * days * 4 / 8).toFixed(1)}
        Arbeitstage
      </td>
    </tr>
    <tr>
      <td>Ein halbes Jahr</td>
      <td>{((minutes * 2) / 60 * days * 26).toFixed(1)} Stunden
        oder {((minutes * 2) / 60 * days * 26 / 8).toFixed(1)}
        Arbeitstage
      </td>
    </tr>
    <tr>
      <td>Ein Jahr</td>
      <td>{((minutes * 2) / 60 * days * 47).toFixed(1)} Stunden
        oder {((minutes * 2) / 60 * days * 47 / 8).toFixed(1)}
        Arbeitstage
      </td>
    </tr>
  </table>

  <p>In einem Monat bist du also {((minutes * 2) / 60 * days * 4 / 8).toFixed(1)} Arbeitstage am pendeln.
    Wenn man die Zeit die du fürs pendeln brauchst zur Arbeitszeit zählt, arbeitest du nicht

      {#if (days === 5)}
        100%, sondern {(100 / (days * 4) * ((days * 4) + ((minutes * 2) / 60 * days * 4 / 8))).toFixed(0) }%
      {/if}
      {#if (days === 4)}
        80%, sondern {(100 / (days * 4) * ((days * 4) + ((minutes * 2) / 60 * days * 4 / 8)) * 0.8).toFixed(0) }%
      {/if}
      {#if (days === 3)}
        60%, sondern {(100 / (days * 4) * ((days * 4) + ((minutes * 2) / 60 * days * 4 / 8)) * 0.6).toFixed(0) }%
      {/if}
      {#if (days === 2)}
        40%, sondern {(100 / (days * 4) * ((days * 4) + ((minutes * 2) / 60 * days * 4 / 8)) * 0.4).toFixed(0) }%
      {/if}
      {#if (days === 1)}
        20%, sondern {(100 / (days * 4) * ((days * 4) + ((minutes * 2) / 60 * days * 4 / 8)) * 0.2).toFixed(0) }%
      {/if}
    für deinen Arbeitgeber.</p>

    {#if ((minutes * 2) / 60 * days * 47 / 8 > 20 && (minutes * 2) / 60 * days * 47 / 8 <40)}
      <p>Nach einem Jahr bist du über ein Arbeitsmonat am pendeln oder genau {((minutes * 2) / 60 * days * 47 / 8).toFixed(0)} Arbeitstage. Lohn dafür bekommst du
        in der Regel nicht dafür.</p>
    {/if}
  {#if ((minutes * 2) / 60 * days * 47 / 8 > 40)}
    <p>Nach einem Jahr bist du über zwei Arbeitsmonate am pendeln oder genau {((minutes * 2) / 60 * days * 47 / 8).toFixed(0)} Arbeitstage. Lohn dafür bekommst du
      in der Regel nicht dafür.</p>
  {/if}

  <p>Im nächsten Abschnitt erklären wir dir, was es für einen ökologischen Unterschied macht, mit dem
  E-Bike zu deinem Arbeitsplatz zu fahren.</p>
  <h2>Bike to work für die Umwelt</h2>
  <div class="drawing three">

  </div>
      <p>Wie sieht es mit der Umwelt aus?
        In der folgenden Tabelle kannst du den CO2 Austoss vergleichen ({selected.text} / E-Bike).
        Ein Mensch sollte pro Jahr
        nicht mehr als 0.6 Tonnen CO2 produzieren, um den Klimawandel zu stoppen.</p>
        {#if (selected.id === 1)}
          <div class="input-block select" style="width: 100%;">
            <label for="select">Der Antrieb deines Autos</label>
            <select bind:value="{antriebselected}" on:change="{changeAntrieb(antriebselected)}">
                {#each antriebe as antrieb}
                  <option value={antrieb}>
                      {antrieb.text}
                  </option>
                {/each}
            </select>
          </div>
        {/if}
      <table>
        <tr>
          <th>Zeitraum</th>
          <th>CO2 (in kg) mit dem {selected.text}</th>
          <th>CO2 (in kg) mit dem E-Bike</th>
        </tr>
        <tr>
          <td>Eine Woche</td>
          <td>
            {(days * 2 * 0.25 * 4 * km * co2level).toFixed(0)}
          </td>
          <td>
            {(days * 2 * 0.25 * 4 * km * 0.004).toFixed(0)}
          </td>
        </tr>
        <tr>
          <td>Ein Monat</td>
          <td>
            {(days * 2 * 4 * km * co2level).toFixed(0)}
          </td>
          <td>
            {(days * 2  * 4 * km * 0.004).toFixed(0)}
          </td>
        </tr>
        <tr>
          <td>Ein halbes Jahr</td>
          <td>
            {(days * 2 * 4 * 6 * km * co2level).toFixed(0)}
          </td>
          <td>
            {(days * 2  * 4 * 6 * km * 0.004).toFixed(0)}
          </td>
        </tr>
        <tr>
          <td>Ein Jahr
          </td>
          <td class="{((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 600 ? 'over-limit' : ''}">
            {(days * 2 * 4 * 12 * km * co2level).toFixed(0)}{#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 600)}*{/if}
          </td>
          <td class="{((days * 2 * 4  * 12 * km * 0.004).toFixed(0)) > 600 ? 'over-limit' : ''}">
            {(days * 2  * 4 * 12 * km * 0.004).toFixed(0)}{#if (((days * 2 * 4  * 12 * km * 0.004).toFixed(0)) > 600)}*{/if}
          </td>
        </tr>
      </table>

        {#if ((days * 2 * 12 * 4 * km * co2level).toFixed(0)) > 600 }
          <p>*Über dem 600kg CO2 Limit in einem Jahr. Ein Mensch sollte pro Jahr
            nicht mehr als 0.6 Tonnen CO2 produzieren, um den Klimawandel zu stoppen.</p>
        {/if}

      <p>{(days * 2 * 4 * 12 * km * co2level).toFixed(0)}kg CO2 nach einem Jahr mit dem {selected.text} ist wie ein Flug nach:
      </p>
      <div class="flight">
      {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 115 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 317 )}
        <h4>München (🇩🇪)</h4>
        <p>Einfach, Economy Class, ca. 300 km, 1 Reisende*r</p>
      {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 317 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 463 )}
          <h4>Lisboa (🇵🇹)</h4>
          <p>Einfach, Economy Class, ca. 1'700 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 464 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 1000 )}
          <h4>Reykjavik (🇮🇸)</h4>
          <p>Einfach, Economy Class, ca. 2'600 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 999 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 1500 )}
          <h4>New York (🇺🇸)</h4>
          <p>Einfach, Economy Class, ca. 6'300 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 1499 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 1700 )}
          <h4>Bangkok (🇹🇭)</h4>
          <p>Einfach, Economy Class, ca. 9'100 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 1699 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 2400 )}
          <h4>Singapore (🇸🇬)</h4>
          <p>Einfach, Economy Class, ca. 10'300 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 2399 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 3300 )}
          <h4>Perth (🇦🇺)</h4>
          <p>Einfach, Economy Class, ca. 13'800 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 3299 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 6600 )}
          <h4>Auckland (🇳🇿)</h4>
          <p>Einfach, Economy Class, ca. 18'400 km, 1 Reisende*r</p>
        {/if}
        {#if (((days * 2 * 4  * 12 * km * co2level).toFixed(0)) > 6599 && ((days * 2 * 4  * 12 * km * co2level).toFixed(0)) < 20000 )}
          <h4>2x Auckland (🇳🇿)</h4>
          <p>Einfach, Economy Class, ca. 18'400 km, 1 Reisende*r</p>
        {/if}
      </div>
  <h2>Bike to work und dein Portemonnaie</h2>
  <div class="drawing two">

  </div>
  <div>
      {#if (selected.id === 1)}
        <p>Mit dem Auto gibst du ungefähr {(km * 2 * 0.7 * days * 4).toFixed(0) } Franken pro Monat aus.
        In einem Jahr sind das {(km * 2 * 0.7 * days * 4 * 12).toFixed(0) } Franken. In dieser Rechnung sind
          Treibstoffkosten, Reifenkosten, Versicherung, Garagierungskosten, Amortisation, Service und Reparaturen inbegriffen.</p>
        {#each {length: (Math.floor((km * 2 * 0.7 * days * 4 * 12) / 100))} as _, i}
          <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
          {/each}
        <p>Zum Vergleich der Service für dein E-Bike oder Velo nach einem Jahr:</p>
        <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
        <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">


        {#if ((km * 2 * 0.7 * days * 4 * 24) > 1000 && (km * 2 * 0.7 * days * 4 * 24) < 20000)}
          <p>Nach zwei Jahren und {(km * 2 * 0.7 * days * 4 * 24).toFixed(0)} Franken hast du für das Auto minimum so viel
            ausgegeben wie für diese Velos:</p>
          <table>
            <th>Velo</th>
            <th>Eigenschaften</th>
            <th>Empfehlung für deine Strecke?</th>

            <tr>
              <td>SCOTT Sub Sport 20 Men</td>
              <td>Preis: CHF 1'199.-<br>
                Typ: Citybike <br>
                Baujahr: 2020 <br>
                Farbe: Silber <br></td>
              <td>Ja</td>

            </tr>
            <tr>
              <td>SCOTT Scale 960</td>
              <td>Preis: CHF 1'499.-<br>
                Typ: Mountainbike <br>
                Baujahr: 2021 <br>
                Farbe: Grün <br></td>
              <td>Ja</td>
            </tr>

          </table>

          {/if}

      {/if}
    {#if (selected.id === 2)}
      <p>Du gibst für den ÖV im Jahr {oev * 12} Franken aus. In zwei Jahren sind das {oev * 24} Franken.</p>
      {#each {length: (oev * 12 / 100)} as _, i}
        <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      {/each}

    <p>Zum Vergleich der Service für dein E-Bike oder Velo nach einem Jahr:</p>
      <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      {#if ((oev * 24) > 1000 && (oev * 24) < 6000)}
        <p>Nach zwei Jahren und {(oev * 24) } Franken hast du so viel für den {selected.text}
        ausgegeben wie für diese Velos:</p>
        <table>
          <th>Velo</th>
          <th>Eigenschaften</th>
          <th>Empfehlung für deine Strecke?</th>

          <tr>
            <td>SCOTT Sub Sport 20 Men</td>
            <td>Preis: CHF 1'199.-<br>
              Typ: Citybike <br>
              Baujahr: 2020 <br>
              Farbe: Silber <br></td>
            <td>Ja</td>

          </tr>
          <tr>
            <td>SCOTT Scale 960</td>
            <td>Preis: CHF 1'499.-<br>
              Typ: Mountainbike <br>
              Baujahr: 2021 <br>
              Farbe: Grün <br></td>
            <td>Ja</td>
          </tr>

        </table>

      {/if}
    {/if}
    {#if (selected.id === 3)}
      <p>Du gibst für den ÖV im Jahr {oev * 12} Franken aus.</p>
      {#each {length: (oev * 12 / 100)} as _, i}
        <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      {/each}

      <p>Zum Vergleich der Service für dein E-Bike oder Velo nach einem Jahr:</p>
      <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      <img src="img/hundret.png" style="height: 15px; margin-right: 5px; width: auto"alt="">
      {#if ((oev * 24) > 1000 && (oev * 24) < 6000)}
        <p>Nach zwei Jahren und {(oev * 24) } Franken hast du so viel für den {selected.text}
          ausgegeben wie für diese Velos:</p>
        <table>
          <th>Velo</th>
          <th>Eigenschaften</th>
          <th>Empfehlung für deine Strecke?</th>

          <tr>
            <td>SCOTT Sub Sport 20 Men</td>
            <td>Preis: CHF 1'199.-<br>
              Typ: Citybike <br>
              Baujahr: 2020 <br>
              Farbe: Silber <br></td>
            <td>Ja</td>

          </tr>
          <tr>
            <td>SCOTT Scale 960</td>
            <td>Preis: CHF 1'499.-<br>
              Typ: Mountainbike <br>
              Baujahr: 2021 <br>
              Farbe: Grün <br></td>
            <td>Ja</td>
          </tr>

        </table>

      {/if}
    {/if}

  </div>
</div>

<style>

  .over-limit {
    background: lightcoral;
  }

  th {
    background: #1d1d1d;
    color: white;
  }

  table {
    width: 100%;
  }

  td, th {
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }



  header {
    background-color: #111;
    padding: 2rem 0;
  }

  .intro-image {
    width: 300px;
    display: block;
    margin: 0 auto;
    filter: invert(1)
  }

</style>
